LS.common = {
	/**
	 * Initialize module
	 */
	init() {
		LS.support.check();

		LS.store.init();
		LS.header.init();

		this.initDark();

		LS.filters.listen();

		LS.user.init();
		LS.analytics.init();

		$.view.addGlobal({
			appUrl: $.get('appUrl'),
			cdnUrl: $.get('cdnUrl')
		});
	},

	/**
	 * Deferred module initialization
	 */
	setup() {
		const scope = this;

		if (window.crawler) {
			return;
		}

		LS.header.locate();

		Apt.auth.bind();

		LS.util.idle([
			scope.initHistory,
			scope.initFooter,
			scope.initCredit,
			scope.initFeedback
		], scope);
	},

	/**
	 * Initialize History navigation
	 */
	initHistory() {
		const scope = this;

		$.history.init({
			partials: 'title, .inner, .js-context',
			processErrors: true,
			scrollTop: conf => {
				const hash = conf.route.hash;

				if (hash) {
					return LS.util.getScroll('#' + hash);
				}

				return 0;
			},
			begin: conf => {
				if (! conf.run) {
					return;
				}

				if (LS.confirm && ! LS.confirm(conf)) {
					return false;
				}

				if (conf.action) {
					$.fetch.abort('api');
				}

				if (conf.event) {
					LS.modal.close();

					scope.transition();
				}

				LS.header.hide();
			},
			end: obj => {
				if (obj.conf.event) {
					scope.transition(true);

					LS.analytics.view();
				}
			},
			request: {
				error: (xhr, conf) => {
					const status = xhr.status;

					if (status) {
						if (status === 403) {
							window.location.href = conf.url;
						}

						LS.error.report('HistoryError', xhr.responseText, {
							status: status,
							url: conf.url
						});
					}
				}
			}
		});
	},

	/**
	 * Set page transition
	 *
	 * @param {Boolean} [end=false]
	 */
	transition(end) {
		const scope = this;
		const className = '-is-navigating';

		if (end) {
			clearTimeout(scope.tt);

			requestAnimationFrame(() => {
				document.body.classList.remove(className);
			});

			return;
		}

		scope.tt = setTimeout(() => {
			document.body.classList.add(className);
		}, 200);
	},

	/**
	 * Initialize footer
	 */
	initFooter() {
		const $form = $$('newsletter');

		LS.api.bind($form, 'mailer/subscriber', {
			method: 'put',
			data: data => {
				data.list_id = 1; // eslint-disable-line
				data.meta = {
					source: $.routes.segments(0)
				};

				return data;
			},
			success: () => {
				LS.analytics.event('newsletter_subscribe');

				$form[0].reset();
			}
		});
	},

	/**
	 * Initialize feedback
	 */
	initFeedback() {
		$$('feedback').on('click', () => {
			LS.util.load('feedback', () => {
				Apt.feedback.init();
			}, true, false);
		}, {
			cancel: true
		});
	},

	/**
	 * Initialize credit
	 */
	initCredit() {
		$$('mapCredit').on('click', () => {
			LS.util.view('maps', 'credit', template => {
				LS.modal.open({
					model: {
						title: 'Data sources and attribution',
						content: template
					}
				});
			});
		}, {
			delegate: document.body
		});
	},

	/**
	 * Initialize dark mode events
	 */
	initDark() {
		const scope = this;

		let dark;

		scope.setDark(scope.isDark(), true);

		$$('dark').on('click', () => {
			dark = scope.isDark();

			scope.setDark(! dark, true);

			LS.analytics.interact('global', 'scheme', dark ?
				'light' : 'dark'
			);
		});

		try {
			window.matchMedia('(prefers-color-scheme: dark)')
				.addEventListener('change', e => {
					scope.setDark(e.matches);
				});
		} catch (e) {
			//
		}
	},

	/**
	 * Get theme state
	 *
	 * @returns {Boolean}
	 */
	isDark() {
		const value = LS.store.get('dark');

		return value === true || (
			value !== false && (
				window.matchMedia &&
				window.matchMedia('(prefers-color-scheme: dark)').matches
			)
		);
	},

	/**
	 * Toggle dark mode
	 *
	 * @param {Boolean} [enable=false]
	 * @param {Boolean} [set=false]
	 */
	setDark(enable, set) {
		const style = $$('darkStyle')[0];
		const schemeClass = '-is-scheming';

		if (! style) {
			return;
		}

		if (set) {
			document.documentElement.classList.add(schemeClass);

			LS.store.set('dark', enable);
		}

		if (enable) {
			document.documentElement.classList.add('-d');

			style.disabled = false;
			style.media = '';
		} else {
			document.documentElement.classList.remove('-d');

			style.disabled = true;
		}

		if (set) {
			$(window).trigger('theme');

			setTimeout(() => {
				document.documentElement.classList.remove(schemeClass);
			}, 300);
		}
	},

	/**
	 * Toggle basic header
	 *
	 * @param {Boolean} [enable=false]
	 * @param enable
	 */
	setBasic(enable) {
		const basicClass = '-is-basic';

		if (enable) {
			document.body.classList.add(basicClass);
		} else {
			document.body.classList.remove(basicClass);
		}
	}
};